import { render, staticRenderFns } from "./admin-list.vue?vue&type=template&id=4e07d9b8&scoped=true&"
import script from "./admin-list.vue?vue&type=script&lang=ts&"
export * from "./admin-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07d9b8",
  null
  
)

export default component.exports